import { AfterViewInit, Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastService, FlagService, DataService } from '@core/services';
import { DomSanitizer } from '@angular/platform-browser';
import { DropdownFrameComponent } from '..';
import { faSpellCheck, faRedo, faHourglass } from '@fortawesome/free-solid-svg-icons';
import { APIClient } from 'src/app/modules/_services/api/@generated';
import { CodeModelDto } from 'src/app/modules/_services/api/@generated/models';

@Component({
  selector: 'app-captcha-juncture',
  templateUrl: './captcha-juncture.component.html',
  styleUrls: ['./captcha-juncture.component.scss'],
  standalone: false
})
export class CaptchaJunctureComponent implements OnInit, AfterViewInit {
  faSpellCheck = faSpellCheck;
  faRedo = faRedo;
  faHourglass = faHourglass;
  captchaPath: any;
  codeModelDto: CodeModelDto = {
    codeText: '',
    generatedAccessToken: ''
  }

  public errorMessage = '';

  _captchaInputValid = false;
  _captchaInput: string;

  constructor(public ToastService: ToastService,public FlagService: FlagService,
              private DropdownFrame: DropdownFrameComponent, private DomSanitizer: DomSanitizer,
              private api: APIClient,
              private dataService: DataService) { }

  ngAfterViewInit(): void {
    window.scrollTo(0, this.dataService.fixInfoContainerHeight + 455 + (this.dataService.isPartneri() ? 65 : 0) + (this.dataService.isKompakt() ? 0 : 60));
  }

  ngOnInit(): void {
    this.getCaptchaPicture();
  }

  getCaptchaPicture() {
    this.api.getCaptcha().subscribe(response => {
      this.codeModelDto.generatedAccessToken = response.accessToken;
      let imgURL = 'data:image/png;base64,' + response.picture;
      this.captchaPath = this.DomSanitizer.bypassSecurityTrustUrl(imgURL);
    }, error => {
      this.ToastService.initializeMessage(error.message, 'error');
    });
  }

  validateCaptcha() {
    this.codeModelDto.codeText = this._captchaInput;
    this.errorMessage = '';
    this.api.checkCaptcha({codeModel: this.codeModelDto}).subscribe(response => {
      if (response.success === 1 || (response.success === 0 && response.errorCode === 107)) {
        this.captchaJunctureClick();
      } else {
        this.errorMessage = response.errorMessage;
        // this.ToastService.initializeMessage(response.errorMessage, 'warning');
        this.reloadCaptcha();
      }
    }, error => {
      // this.ToastService.initializeMessage(error.message, 'error');
      this.errorMessage = error.error?.validationErrors[0]?.errorMessage;
    });
  }

  reloadCaptcha() {
    this.getCaptchaPicture();
    this._captchaInputValid = false;
    this._captchaInput = '';
    this.errorMessage = '';
  }

  captchaInputChange(event: any) {
    event.length > 0? this._captchaInputValid = true : this._captchaInputValid = false;
  }

  captchaJunctureClick() {
    this.DropdownFrame.junctureClick('finalpaymentJunctureFlag', 9);
  }

  public feedbackClick(): void {
    this.reloadCaptcha();
    this.captchaJunctureClick();
  }
}
